module.exports = __webpack_public_path__ + "mainTitle.63002f63.png";